
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { UsersTable } from './UsersTable';
import { User } from '@/types/user';

interface UsersContentProps {
  users: User[];
  filteredUsers: User[];
  onUserUpdated: () => void;
  onManualRefresh: () => void;
  refreshing: boolean;
}

export function UsersContent({ 
  users, 
  filteredUsers, 
  onUserUpdated, 
  onManualRefresh, 
  refreshing 
}: UsersContentProps) {
  if (users.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">
          No users found. Start by inviting your first admin user.
        </p>
        <Button 
          variant="outline" 
          onClick={onManualRefresh}
          disabled={refreshing}
          className="mt-2"
        >
          <RefreshCw className={`mr-2 h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>
    );
  }

  return <UsersTable users={filteredUsers} onUserUpdated={onUserUpdated} />;
}
